<template>
  <div class="mains">
    <div class="campus">
      小程序管理
      <span>></span>
      <router-link to="staff">教材设置</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content xcx_qxsz">
          <div class="xiaoqu_1">教材设置</div>
          <div class="quanxiantishi">
            您可在此处进行小程序的教材权限的设置，请您勾选显示在小程序端的教材~
          </div>
          <div class="sousuo">
            <!-- <span>小程序：</span>
            <el-dropdown>
              <el-button type="primary" class="xuanze">
                {{ xuanze }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="dropdowns xcx_dropdowns" slot="dropdown">
                <el-dropdown-item @click.native="guanli(item), chaxun(item)" v-for="(item, index) in xuanzejuese" :key="index">
                  {{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <span>机构名称：</span>
            <el-input v-model="orgname" @keyup.13.native="chaxun" placeholder="请输入机构名称搜索"></el-input>
            <el-button type="primary" class="buttons" @click="chaxun()">
              查 询
            </el-button>
          </div>
          <div class="zsbg jigou_xcx">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="orgname" label="机构名称"></el-table-column>
              <el-table-column prop="mininame" label="所拥有小程序"></el-table-column>
              <el-table-column prop="true_name" label="小程序实名"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <!--<el-button type="text">APP下载页</el-button>-->
                  <el-button type="text" class="caozuo" @click="shezhi(stData.row.miniid)">
                    设置教材
                  </el-button>
                  <el-button v-if="canManageModule(stData.row.miniid)" type="text" @click="$router.push({ name: 'moduleAccess', query: { miniid: stData.row.miniid } })">模块权限</el-button>
                  <el-button type="text" class="caozuo" @click="addTeachBook(stData.row)">
                    添加教材
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>

          <el-dialog title="设置教材" :visible.sync="addStudents">
            <div class="form_1 form_1_1 xcx_sz">
              <el-form ref="Trialscope" :model="Trialscopes" :rules="FormRules">
                <el-form-item>
                  <div class="fanwei1 scrollbarStyle">
                    <div class="shezhi_tree">
                      <el-tree :data="tree" show-checkbox node-key="id" :default-expanded-keys="dk_neirong"
                        :default-checked-keys="xz_neirong" @check="xuanzhong">
                      </el-tree>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="updateOrgMiniBook">确定</el-button>
                  <el-button @click="quexiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { moduleAccessAdminEnabled, getAccessMinis } from '@/api/moduleAccess';
export default {
  name: 'staff',
  data() {
    return {
      moduleAccessAdminEnabled,
      allowedMiniIds: [],
      Trialscopes: {},
      orgname: '',
      xcx_type: '',
      tableData: [],
      form: {
        username: '',
        name: '',
        rolecode: '',
        sex: '1',
        classid: '',
        phone: '',
        email: '',
      },
      FormRules: {},
      xuanze: '选择小程序',
      xuanzejuese: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 5,
      currentPage: 1,
      total: 0,
      addStudents: false,
      miniid: '',
      getBookGoupList: [],
      tree: [],
      dk_neirong: [],
      xz_neirong: [],
    };
  },
  mounted() {
    this.juese();
    this.chaxun();
    this.loadAllowedMinis();
  },
  watch: {},
  methods: {
    canManageModule(miniid) {
      return this.moduleAccessAdminEnabled && this.allowedMiniIds.some(id => Number(id) === Number(miniid));
    },
    // 按钮候选取真实后端管理范围，角色展示不能代替机构归属校验；失败时不展示可编辑按钮。
    async loadAllowedMinis() {
      if (!this.moduleAccessAdminEnabled) return;
      try {
        const minis = await getAccessMinis();
        this.allowedMiniIds = (minis || []).map(mini => mini.id);
      } catch (error) {
        this.allowedMiniIds = [];
      }
    },
    juese() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/getMiniTypeList',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          this.xuanzejuese = result.data.miniTypeList;
          // console.log(result.data.miniTypeList)
          // console.log(this.xuanzejuese)
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('获得小程序列表失败：' + err);
        });
    },
    chaxun(e) {
      // var code = ''
      // if (e !== undefined) {
      //   code = e.code
      // }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/mini/miniInfo/selectOrgMiniList?type=' + this.xcx_type + '&orgname=' + this.orgname + '&page=' + this.page + '&pageSize=' + this.pageSize,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var data = result.data.data;
          this.tableData = data;
          if (data === undefined || data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('获得机构列表失败：' + err);
        });
    },
    handleSizeChange(val) {
      // console.log(val)
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.chaxun();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.chaxun();
    },
    guanli(e) {
      // console.log(e)
      this.xuanze = e.name;
      this.xcx_type = e.type;
    },

    updateOrgMiniBook() {
      var list = [];
      for (var i = 0; i < this.tree.length; i++) {
        for (var j = 0; j < this.tree[i].children.length; j++) {
          // console.log(this.tree[i].children, '12')
          if (this.tree[i].children[j].selected === 1) {
            list.push(this.tree[i].children[j]);
            // console.log(list, '12')
          }
        }
      }

      var time = setInterval(() => {
        // console.log('result')
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: '/mini/miniBook/updateOrgMiniBook/' + orgid + '/' + this.miniid,
          method: 'POST',
          data: list,
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.addStudents = false;
            return this.$message.success('设置教材成功!');
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('设置教材失败：' + err);
          });
        clearInterval(time);
      }, 500);
    },

    xuanzhong(e, n) {
      // console.log(e, 'e')
      // console.log(n, 'n')
      for (var i = 0; i < this.tree.length; i++) {
        for (var j = 0; j < this.tree[i].children.length; j++) {
          // console.log(this.tree[i].children[j])
          if (e.children === null) {
            // console.log('null')
            if (this.tree[i].children[j].id === e.id && this.tree[i].children[j].selected === 0) {
              // console.log(this.tree[i].children[j])
              this.tree[i].children[j].selected = 1;
              // console.log(this.tree[0])
            } else if (this.tree[i].children[j].id === e.id && this.tree[i].children[j].selected === 1) {
              this.tree[i].children[j].selected = 0;
              // console.log(this.tree[0])
            }
          } else {
            // console.log('you')
            if (this.tree[i].id === e.id && this.tree[i].children[j].selected === 0) {
              // console.log(this.tree[i].children[j])
              // console.log('you1')
              this.tree[i].children.forEach((item) => {
                item.selected = 1;
              });
              return false;
            } else if (this.tree[i].id === e.id && this.tree[i].children[j].selected === 1) {
              // console.log(this.tree[i].children[j])
              // console.log('you2')
              this.tree[i].children[j].selected = 0;
            }
          }
        }
      }
    },
    shezhi(id) {
      // console.log(id)
      this.miniid = id;
      this.addStudents = true;
      this.xz_neirong = [];
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/mini/miniBook/getBookGoupList?orgid=' + orgid + '&miniid=' + id,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data[0].children)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tree = result.data.data[0].children;
          for (var i = 0; i < this.tree.length; i++) {
            // console.log(this.tree[i])
            this.dk_neirong = [this.tree[0].id];
            for (var j = 0; j < this.tree[i].children.length; j++) {
              // console.log(this.tree[i].children[j])
              if (this.tree[i].children[j].selected === 1) {
                this.xz_neirong.push(this.tree[i].children[j].id);
                // console.log(this.xz_neirong)
              }
            }
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('获得教材列表失败：' + err);
        });
    },
    // 添加教材跳转
    addTeachBook(row){
      console.log(row);
      this.$router.push({
        path:'/addMaterial',
        query:{
          orgId:row.orgid,
          miniId:row.miniid
        }
      })
    },
    quexiao() {
      this.addStudents = false;
    },
  },
};
</script>

<style lang="less">
.mains .xiaoqu .xcx_qxsz {
  .quanxiantishi {
    color: #ccc;
    font-size: 12px;
  }
  .sousuo {
    margin-top: -30px;
  }
}
.mains .xiaoqu .grid-content {
  .jigou_xcx .el-table {
    .el-table_1_column_1 {
      padding-left: 11% !important;
    }
    .el-table_1_column_2 {
      text-align: center;
      padding-left: 0;
    }
  }
  .el-dialog .xcx_sz {
    .fanwei1 {
      width: 520px;
      height: 400px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
      // margin: 5px 0 0 11px;
      line-height: 1;
      overflow: auto;
    }
    .queding {
      margin: 1.04167vw 0 0 0;
      position: relative;
      left: 320px;
    }
  }

  .shezhi_tree {
    .el-tree {
      .el-tree-node__content {
        background: none !important;
        color: #666 !important;
      }
      .el-tree-node__expand-icon.expanded {
        transform: rotate(0deg);
        display: block;
        background: url('../../../assets/img/functional-module/listening/kai.png') no-repeat !important;
      }
      .el-tree-node__expand-icon:first-child {
        width: 18px !important;
        height: 18px !important;
        background: url('../../../assets/img/functional-module/listening/guan.png') no-repeat;
      }
      .el-tree-node__children .is-checked .el-tree-node__label {
        color: #666 !important;
      }
      .el-tree-node__children .is-current .el-tree-node__label {
        color: #666 !important;
      }
      .el-tree-node__children {
        .is-current {
          .el-tree-node__expand-icon {
            background: url('../../../assets/img/functional-module/listening/guan.png') no-repeat !important;
          }
        }
        .is-checked {
          .el-tree-node__expand-icon {
            background: url('../../../assets/img/functional-module/listening/guan.png') no-repeat !important;
          }
        }
        .el-tree-node {
          margin-bottom: 14px;
        }
        .el-checkbox__inner {
          position: absolute;
          left: 400px;
          top: -9px;
        }
      }
      .el-checkbox__inner {
        position: absolute;
        left: 420px;
        top: -9px;
      }

      .el-checkbox__inner {
        border: 1px solid #666;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-color: #409eff;
      }
    }
  }
}
.xcx_dropdowns {
  left: 1313px !important;
}
</style>
